import networkAction from '@gluedigital/network-action'

const apiHost = process.env.API_HOST || 'http://localhost:3000'

const apiAction = networkAction.withDefaults({
  baseUrl: apiHost + '/api'
})

export const sendFormHubspot = email => async () => {
  const action =
    'https://api.hsforms.com/submissions/v3/integration/submit/' +
    process.env.HUBSPOT_FORM
  const res = await fetch(action, {
    method: 'POST',
    body: JSON.stringify({
      fields: [{ name: 'email', value: email }]
    }),
    headers: { 'Content-Type': 'application/json' }
  })
  const data = await res.json()
  if (res.ok) {
    return true
  } else {
    const msg = data && data.errors && data.errors.map(e => e.message).join('\n')
    console.warn('Error sending form:\n', msg || '(Unknown error)')
    throw new Error('Error sending form')
  }
}

export const sendForm = (email) => apiAction({
  action: 'sendForm',
  url: '/form',
  body: { email }
})
